// extracted by mini-css-extract-plugin
export default {"container":"Header_container__0Fuup","load_header":"Header_load_header__cemxa","img_container":"Header_img_container__ue+9p","logo_text":"Header_logo_text__JzRtu"};